"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdFormik = require("cccisd-formik");
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross"));
var _Condition = _interopRequireDefault(require("../Condition"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var generateNewId = function generateNewId() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return array.length === 0 ? 1 : Math.max.apply(Math, _toConsumableArray(array.map(function (item) {
    return item.id;
  }))) + 1;
};
var aggregationOptions = [{
  value: 'all',
  label: 'All'
}, {
  value: 'any',
  label: 'Any'
}];
var Level = function Level(props) {
  var path = props.path,
    values = props.values;
  var level = path ? (0, _get2["default"])(values, path) : values;
  var prefix = path ? path + '.' : '';
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].aggregation
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "filter.".concat(prefix, "aggregation"),
    component: _cccisdFormik.CccisdSelect,
    options: aggregationOptions,
    style: {
      width: 'auto'
    }
  }), /*#__PURE__*/_react["default"].createElement("div", null, "of the following are true")), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].conditions
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.FieldArray, {
    name: "filter.".concat(prefix, "conditions"),
    render: function render(arrayHelpers) {
      return /*#__PURE__*/_react["default"].createElement("div", null, level.conditions.length === 0 && /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-danger"
      }, "At least one condition is required"), level.conditions.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: item.id,
          style: {
            display: 'flex'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"]["delete"],
          onClick: function onClick() {
            return arrayHelpers.remove(index);
          }
        }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), item.conditions ? /*#__PURE__*/_react["default"].createElement(Level, _extends({}, props, {
          path: "".concat(prefix, "conditions[").concat(index, "]")
        })) : /*#__PURE__*/_react["default"].createElement(_Condition["default"], {
          path: "".concat(prefix, "conditions[").concat(index, "]"),
          condition: item
        }));
      }), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-success btn-xs",
        onClick: function onClick() {
          return arrayHelpers.push({
            id: generateNewId(level.conditions),
            column: null,
            operator: ''
          });
        }
      }, "Add condition"), ' ', /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-success btn-xs",
        onClick: function onClick() {
          return arrayHelpers.push({
            id: generateNewId(level.conditions),
            aggregation: 'all',
            conditions: [{
              id: 1,
              column: null,
              operator: ''
            }]
          });
        }
      }, "Add condition set"));
    }
  })));
};
Level.propTypes = {
  path: _propTypes["default"].string,
  values: _propTypes["default"].object
};
Level.defaultProps = {};
var _default = Level;
exports["default"] = _default;